var _rect, _rect2, _rect3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperMagnify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 10,
    y: 14,
    width: 16,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 10,
    y: 22,
    width: 16,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 10,
    y: 30,
    width: 12,
    height: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,43c-0.7,0-1.4-0.1-2.1-0.3c-2,2-4.8,3.3-7.8,3.3H2V2h32v23.1c0.7,0.1,1.4,0.2,2,0.5V0H0v48h23  c4.2,0,7.9-2,10.3-5.1C33.2,43,33.1,43,32.9,43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 47.5l-7.5-7.5c-1.3 1-2.9 1.6-4.6 1.6-4.1 0-7.4-3.3-7.4-7.4s3.3-7.4 7.4-7.4 7.4 3.3 7.4 7.4c0 1.7-0.6 3.3-1.6 4.6l7.5 7.5-1.2 1.2zm-12.1-19.1c-3.1 0-5.7 2.5-5.7 5.7s2.5 5.7 5.7 5.7 5.7-2.5 5.7-5.7-2.6-5.7-5.7-5.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperMagnify);
export default __webpack_public_path__ + "static/media/paper-magnify.c9b246984a054d520bfd3027b1fe9f95.svg";
export { ForwardRef as ReactComponent };